import { render } from "./InputUi.vue?vue&type=template&id=52f15e08&ts=true"
import script from "./InputUi.vue?vue&type=script&lang=ts"
export * from "./InputUi.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__